var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexagons1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1073,
    height: 1055,
    viewBox: "0 0 1073 1055",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_59_598)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 568.5,
    cy: 492.5,
    r: 306.5,
    fill: "#8DD7EF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.1143 662.65L123.11 681.231L155.703 661.941L155.296 624.076L122.299 605.495L89.7104 624.78L90.1143 662.65Z",
    fill: "#4F859A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.631 603.131L156.628 621.712L189.217 602.427L188.813 564.557L155.817 545.976L123.224 565.265L123.631 603.131Z",
    fill: "#4F859A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.148 543.611L190.144 562.192L222.733 542.908L222.329 505.037L189.333 486.456L156.741 505.746L157.148 543.611Z",
    fill: "#4F859A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.665 484.092L223.661 502.672L256.25 483.388L255.843 445.523L222.847 426.942L190.258 446.226L190.665 484.092Z",
    fill: "#4F859A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M358.249 186.494L391.245 205.075L423.834 185.791L423.427 147.925L390.431 129.344L357.842 148.629L358.249 186.494Z",
    fill: "#4F859A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.766 126.974L424.762 145.555L457.351 126.271L456.944 88.4059L423.948 69.825L391.359 89.1092L391.766 126.974Z",
    fill: "#4F859A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.228 424.49L257.224 443.07L289.816 423.781L289.409 385.916L256.413 367.335L223.824 386.619L224.228 424.49Z",
    fill: "#4F859A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.745 364.97L290.741 383.551L323.33 364.267L322.926 326.396L289.93 307.815L257.338 327.105L257.745 364.97Z",
    fill: "#4F859A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M291.262 305.45L324.258 324.031L356.847 304.747L356.443 266.877L323.447 248.296L290.855 267.585L291.262 305.45Z",
    fill: "#4F859A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.779 245.931L357.775 264.512L390.364 245.228L389.96 207.357L356.964 188.776L324.372 208.066L324.779 245.931Z",
    fill: "#4F859A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3496 662.954L54.3458 681.535L86.9349 662.25L86.5279 624.385L53.5318 605.804L20.9426 625.089L21.3496 662.954Z",
    fill: "#4F859A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8667 603.434L87.8629 622.015L120.452 602.731L120.045 564.866L87.0488 546.285L54.4597 565.569L54.8667 603.434Z",
    fill: "#4F859A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3833 543.915L121.379 562.496L153.969 543.211L153.562 505.346L120.565 486.765L87.9763 506.05L88.3833 543.915Z",
    fill: "#4F859A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.9 484.395L154.897 502.976L187.486 483.692L187.079 445.827L154.083 427.246L121.493 446.53L121.9 484.395Z",
    fill: "#4F859A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M289.481 186.803L322.478 205.384L355.07 186.094L354.663 148.229L321.667 129.648L289.078 148.932L289.481 186.803Z",
    fill: "#4F859A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.998 127.283L355.994 145.864L388.583 126.58L388.179 88.7095L355.183 70.1286L322.591 89.4183L322.998 127.283Z",
    fill: "#4F859A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M356.706 66.5383L389.702 85.1192L422.291 65.835L421.884 27.9699L388.888 9.38901L356.299 28.6732L356.706 66.5383Z",
    fill: "#4F859A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.463 424.793L188.46 443.374L221.049 424.09L220.642 386.225L187.646 367.644L155.056 386.928L155.463 424.793Z",
    fill: "#4F859A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.98 365.274L221.977 383.854L254.566 364.57L254.159 326.705L221.163 308.124L188.573 327.408L188.98 365.274Z",
    fill: "#4F859A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.497 305.754L255.493 324.335L288.082 305.051L287.675 267.186L254.679 248.605L222.09 267.889L222.497 305.754Z",
    fill: "#4F859A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M256.014 246.235L289.01 264.815L321.599 245.531L321.192 207.666L288.196 189.085L255.607 208.369L256.014 246.235Z",
    fill: "#4F859A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M159.69 662.963L192.687 681.544L225.276 662.26L224.869 624.394L191.873 605.814L159.283 625.098L159.69 662.963Z",
    fill: "#4F859A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M193.208 603.443L226.204 622.024L258.793 602.74L258.386 564.875L225.39 546.294L192.801 565.578L193.208 603.443Z",
    fill: "#4F859A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M226.724 543.924L259.72 562.505L292.309 543.221L291.902 505.355L258.906 486.775L226.317 506.059L226.724 543.924Z",
    fill: "#4F859A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M260.241 484.404L293.237 502.985L325.827 483.701L325.419 445.836L292.423 427.255L259.834 446.539L260.241 484.404Z",
    fill: "#4F859A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M427.822 186.812L460.818 205.393L493.411 186.103L493.004 148.238L460.007 129.657L427.418 148.942L427.822 186.812Z",
    fill: "#4F859A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M461.339 127.293L494.335 145.874L526.927 126.584L526.52 88.7187L493.524 70.1378L460.935 89.4221L461.339 127.293Z",
    fill: "#4F859A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M125.18 724.248L158.176 742.829L190.765 723.544L190.358 685.679L157.362 667.098L124.773 686.383L125.18 724.248Z",
    fill: "#4F859A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M230.349 783.471L263.345 802.052L295.934 782.768L295.527 744.903L262.531 726.322L229.942 745.606L230.349 783.471Z",
    fill: "#4F859A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M335.848 843.873L368.844 862.453L401.433 843.169L401.026 805.304L368.03 786.723L335.441 806.007L335.848 843.873Z",
    fill: "#4F859A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M440.917 905.038L473.913 923.619L506.505 904.329L506.098 866.464L473.102 847.883L440.513 867.168L440.917 905.038Z",
    fill: "#4F859A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M546.086 964.262L579.083 982.843L611.675 963.553L611.268 925.688L578.272 907.107L545.683 926.391L546.086 964.262Z",
    fill: "#4F859A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M648.035 1025.66L681.031 1044.24L713.62 1024.95L713.213 987.087L680.217 968.506L647.628 987.79L648.035 1025.66Z",
    fill: "#4F859A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M293.804 424.802L326.8 443.383L359.389 424.099L358.982 386.234L325.986 367.653L293.397 386.937L293.804 424.802Z",
    fill: "#4F859A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M327.321 365.283L360.317 383.864L392.907 364.579L392.5 326.714L359.503 308.133L326.914 327.418L327.321 365.283Z",
    fill: "#4F859A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M360.838 305.763L393.835 324.344L426.424 305.06L426.017 267.195L393.021 248.614L360.431 267.898L360.838 305.763Z",
    fill: "#4F859A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M394.355 246.244L427.351 264.825L459.94 245.54L459.533 207.675L426.537 189.094L393.948 208.379L394.355 246.244Z",
    fill: "#4F859A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195.107 722.766L228.103 741.347L260.692 722.063L260.285 684.198L227.289 665.617L194.7 684.901L195.107 722.766Z",
    fill: "#4F859A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M228.624 663.247L261.62 681.828L294.209 662.544L293.802 624.678L260.806 606.098L228.217 625.382L228.624 663.247Z",
    fill: "#4F859A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M262.141 603.727L295.137 622.308L327.726 603.024L327.319 565.159L294.323 546.578L261.734 565.862L262.141 603.727Z",
    fill: "#4F859A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M295.658 544.208L328.654 562.789L361.243 543.505L360.836 505.639L327.84 487.059L295.251 506.343L295.658 544.208Z",
    fill: "#4F859A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M463.239 246.616L496.235 265.196L528.824 245.912L528.42 208.042L495.424 189.461L462.832 208.75L463.239 246.616Z",
    fill: "#4F859A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M496.756 187.096L529.752 205.677L562.341 186.393L561.937 148.522L528.941 129.941L496.349 149.231L496.756 187.096Z",
    fill: "#4F859A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M329.221 484.606L362.217 503.187L394.806 483.902L394.399 446.037L361.403 427.456L328.814 446.741L329.221 484.606Z",
    fill: "#4F859A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M362.738 425.086L395.734 443.667L428.323 424.383L427.916 386.518L394.92 367.937L362.331 387.221L362.738 425.086Z",
    fill: "#4F859A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 365.567L429.251 384.148L461.84 364.863L461.433 326.998L428.437 308.417L395.848 327.702L396.255 365.567Z",
    fill: "#4F859A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M429.772 306.047L462.768 324.628L495.357 305.344L494.95 267.479L461.954 248.898L429.365 268.182L429.772 306.047Z",
    fill: "#4F859A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M265.192 723.373L298.188 741.954L330.78 722.664L330.373 684.799L297.377 666.218L264.788 685.502L265.192 723.373Z",
    fill: "#4F859A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M298.709 663.853L331.705 682.434L364.294 663.15L363.89 625.279L330.894 606.698L298.302 625.988L298.709 663.853Z",
    fill: "#4F859A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M332.226 604.334L365.222 622.915L397.811 603.63L397.407 565.76L364.411 547.179L331.819 566.469L332.226 604.334Z",
    fill: "#4F859A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M365.743 544.814L398.739 563.395L431.328 544.111L430.921 506.246L397.925 487.665L365.336 506.949L365.743 544.814Z",
    fill: "#4F859A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M533.327 247.216L566.323 265.797L598.912 246.513L598.505 208.648L565.509 190.067L532.92 209.351L533.327 247.216Z",
    fill: "#4F859A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M566.844 187.697L599.84 206.278L632.429 186.994L632.022 149.128L599.026 130.548L566.437 149.832L566.844 187.697Z",
    fill: "#4F859A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M399.306 485.212L432.302 503.793L464.894 484.503L464.487 446.638L431.491 428.057L398.902 447.342L399.306 485.212Z",
    fill: "#4F859A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M432.823 425.693L465.819 444.273L498.411 424.984L498.004 387.119L465.008 368.538L432.419 387.822L432.823 425.693Z",
    fill: "#4F859A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M466.339 366.173L499.336 384.754L531.925 365.47L531.521 327.599L498.525 309.018L465.932 328.308L466.339 366.173Z",
    fill: "#4F859A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M499.856 306.654L532.853 325.234L565.442 305.95L565.038 268.08L532.042 249.499L499.449 268.788L499.856 306.654Z",
    fill: "#4F859A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M300.603 783.173L333.599 801.754L366.188 782.47L365.784 744.599L332.788 726.018L300.196 745.308L300.603 783.173Z",
    fill: "#4F859A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M334.12 723.654L367.116 742.234L399.705 722.95L399.298 685.085L366.302 666.504L333.713 685.788L334.12 723.654Z",
    fill: "#4F859A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M367.637 664.134L400.633 682.715L433.222 663.431L432.815 625.566L399.819 606.985L367.23 626.269L367.637 664.134Z",
    fill: "#4F859A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M401.153 604.615L434.149 623.195L466.739 603.911L466.332 566.046L433.335 547.465L400.746 566.749L401.153 604.615Z",
    fill: "#4F859A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M568.738 307.017L601.734 325.598L634.323 306.314L633.916 268.448L600.92 249.867L568.331 269.152L568.738 307.017Z",
    fill: "#4F859A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M602.254 247.497L635.251 266.078L667.84 246.794L667.433 208.929L634.437 190.348L601.847 209.632L602.254 247.497Z",
    fill: "#4F859A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M434.717 545.012L467.713 563.593L500.302 544.309L499.898 506.439L466.902 487.858L434.31 507.147L434.717 545.012Z",
    fill: "#4F859A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M468.233 485.493L501.23 504.074L533.819 484.79L533.412 446.925L500.416 428.344L467.826 447.628L468.233 485.493Z",
    fill: "#4F859A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M501.751 425.973L534.747 444.554L567.336 425.27L566.929 387.405L533.933 368.824L501.344 388.108L501.751 425.973Z",
    fill: "#4F859A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M535.267 366.454L568.263 385.035L600.852 365.751L600.445 327.885L567.449 309.305L534.86 328.589L535.267 366.454Z",
    fill: "#4F859A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M370.185 783.489L403.181 802.07L435.77 782.786L435.363 744.921L402.367 726.34L369.778 745.624L370.185 783.489Z",
    fill: "#4F859A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M403.702 723.969L436.698 742.55L469.287 723.266L468.88 685.401L435.884 666.82L403.295 686.104L403.702 723.969Z",
    fill: "#4F859A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M437.218 664.45L470.214 683.031L502.804 663.747L502.397 625.882L469.4 607.301L436.811 626.585L437.218 664.45Z",
    fill: "#4F859A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M470.735 604.93L503.732 623.511L536.321 604.227L535.914 566.362L502.917 547.781L470.328 567.065L470.735 604.93Z",
    fill: "#4F859A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M638.316 307.338L671.313 325.919L703.902 306.635L703.498 268.764L670.502 250.184L637.909 269.473L638.316 307.338Z",
    fill: "#4F859A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M671.834 247.819L704.83 266.4L737.419 247.115L737.015 209.245L704.019 190.664L671.426 209.954L671.834 247.819Z",
    fill: "#4F859A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M504.299 545.328L537.295 563.909L569.884 544.625L569.477 506.76L536.481 488.179L503.892 507.463L504.299 545.328Z",
    fill: "#4F859A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M537.815 485.809L570.812 504.39L603.401 485.106L602.994 447.24L569.998 428.66L537.408 447.944L537.815 485.809Z",
    fill: "#4F859A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M571.333 426.289L604.329 444.87L636.918 425.586L636.511 387.721L603.515 369.14L570.926 388.424L571.333 426.289Z",
    fill: "#4F859A"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M604.849 366.77L637.845 385.351L670.434 366.066L670.027 328.201L637.031 309.62L604.442 328.905L604.849 366.77Z",
    fill: "#4F859A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M406.107 843.577L439.104 862.158L471.693 842.874L471.286 805.009L438.29 786.428L405.7 805.712L406.107 843.577Z",
    fill: "#4F859A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M439.624 784.058L472.62 802.639L505.209 783.355L504.802 745.49L471.806 726.909L439.217 746.193L439.624 784.058Z",
    fill: "#4F859A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M473.141 724.538L506.137 743.119L538.726 723.835L538.319 685.97L505.323 667.389L472.734 686.673L473.141 724.538Z",
    fill: "#4F859A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M506.658 665.019L539.654 683.6L572.243 664.316L571.836 626.45L538.84 607.87L506.251 627.154L506.658 665.019Z",
    fill: "#4F859A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M674.239 367.427L707.235 386.008L739.825 366.723L739.418 328.858L706.421 310.277L673.832 329.561L674.239 367.427Z",
    fill: "#4F859A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M707.756 307.907L740.752 326.488L773.341 307.204L772.934 269.339L739.938 250.758L707.349 270.042L707.756 307.907Z",
    fill: "#4F859A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M540.221 605.417L573.217 623.998L605.806 604.714L605.399 566.848L572.403 548.267L539.814 567.552L540.221 605.417Z",
    fill: "#4F859A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M573.738 545.897L606.734 564.478L639.323 545.194L638.916 507.329L605.92 488.748L573.331 508.032L573.738 545.897Z",
    fill: "#4F859A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M607.255 486.378L640.251 504.959L672.84 485.674L672.433 447.809L639.437 429.228L606.848 448.513L607.255 486.378Z",
    fill: "#4F859A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M640.769 426.864L673.765 445.445L706.357 426.155L705.95 388.29L672.954 369.709L640.365 388.993L640.769 426.864Z",
    fill: "#4F859A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M475.681 843.896L508.677 862.477L541.266 843.192L540.862 805.322L507.866 786.741L475.274 806.031L475.681 843.896Z",
    fill: "#4F859A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M509.197 784.376L542.193 802.957L574.783 783.673L574.379 745.802L541.383 727.221L508.79 746.511L509.197 784.376Z",
    fill: "#4F859A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M542.714 724.857L575.711 743.438L608.3 724.153L607.893 686.288L574.897 667.707L542.307 686.992L542.714 724.857Z",
    fill: "#4F859A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M576.231 665.337L609.227 683.918L641.816 664.634L641.409 626.769L608.413 608.188L575.824 627.472L576.231 665.337Z",
    fill: "#4F859A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M743.815 367.739L776.812 386.32L809.401 367.036L808.994 329.171L775.998 310.59L743.408 329.874L743.815 367.739Z",
    fill: "#4F859A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M777.332 308.22L810.328 326.801L842.917 307.517L842.51 269.651L809.514 251.071L776.925 270.355L777.332 308.22Z",
    fill: "#4F859A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M609.794 605.735L642.791 624.316L675.38 605.032L674.976 567.161L641.98 548.58L609.387 567.87L609.794 605.735Z",
    fill: "#4F859A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M643.311 546.216L676.307 564.796L708.896 545.512L708.489 507.647L675.493 489.066L642.904 508.35L643.311 546.216Z",
    fill: "#4F859A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M676.828 486.696L709.824 505.277L742.413 485.993L742.006 448.128L709.01 429.547L676.421 448.831L676.828 486.696Z",
    fill: "#4F859A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M710.345 427.177L743.341 445.757L775.93 426.473L775.523 388.608L742.527 370.027L709.938 389.311L710.345 427.177Z",
    fill: "#4F859A"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M510.951 903.175L543.947 921.756L576.536 902.472L576.129 864.606L543.133 846.026L510.544 865.31L510.951 903.175Z",
    fill: "#4F859A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M544.467 843.655L577.463 862.236L610.053 842.952L609.649 805.081L576.653 786.501L544.06 805.79L544.467 843.655Z",
    fill: "#4F859A"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M577.984 784.136L610.981 802.717L643.57 783.433L643.163 745.567L610.167 726.987L577.577 746.271L577.984 784.136Z",
    fill: "#4F859A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M611.501 724.616L644.497 743.197L677.086 723.913L676.679 686.048L643.683 667.467L611.094 686.751L611.501 724.616Z",
    fill: "#4F859A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M779.085 427.019L812.082 445.6L844.671 426.315L844.264 388.45L811.268 369.869L778.678 389.154L779.085 427.019Z",
    fill: "#4F859A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M812.602 367.499L845.598 386.08L878.187 366.796L877.78 328.931L844.784 310.35L812.195 329.634L812.602 367.499Z",
    fill: "#4F859A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M645.064 665.014L678.061 683.595L710.65 664.311L710.243 626.446L677.247 607.865L644.657 627.149L645.064 665.014Z",
    fill: "#4F859A"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M678.581 605.495L711.577 624.076L744.166 604.791L743.762 566.921L710.766 548.34L678.174 567.63L678.581 605.495Z",
    fill: "#4F859A"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M712.098 545.975L745.094 564.556L777.683 545.272L777.276 507.407L744.28 488.826L711.691 508.11L712.098 545.975Z",
    fill: "#4F859A"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M745.615 486.456L778.611 505.037L811.2 485.752L810.793 447.887L777.797 429.306L745.208 448.591L745.615 486.456Z",
    fill: "#4F859A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M580.527 903.488L613.523 922.069L646.112 902.784L645.705 864.919L612.709 846.338L580.12 865.623L580.527 903.488Z",
    fill: "#4F859A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M614.043 843.968L647.04 862.549L679.629 843.265L679.222 805.4L646.226 786.819L613.636 806.103L614.043 843.968Z",
    fill: "#4F859A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M647.561 784.449L680.557 803.029L713.146 783.745L712.739 745.88L679.743 727.299L647.154 746.583L647.561 784.449Z",
    fill: "#4F859A"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M681.077 724.929L714.073 743.51L746.662 724.226L746.255 686.361L713.259 667.78L680.67 687.064L681.077 724.929Z",
    fill: "#4F859A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M848.659 427.337L881.655 445.918L914.244 426.633L913.84 388.763L880.844 370.182L848.252 389.472L848.659 427.337Z",
    fill: "#4F859A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M882.175 367.817L915.171 386.398L947.761 367.114L947.354 329.249L914.357 310.668L881.768 329.952L882.175 367.817Z",
    fill: "#4F859A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M714.641 665.327L747.637 683.908L780.226 664.624L779.819 626.759L746.823 608.178L714.234 627.462L714.641 665.327Z",
    fill: "#4F859A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M748.158 605.807L781.154 624.388L813.743 605.104L813.336 567.239L780.34 548.658L747.751 567.942L748.158 605.807Z",
    fill: "#4F859A"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M781.674 546.288L814.67 564.869L847.26 545.585L846.853 507.72L813.856 489.139L781.267 508.423L781.674 546.288Z",
    fill: "#4F859A"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M815.191 486.768L848.187 505.349L880.776 486.065L880.369 448.2L847.373 429.619L814.784 448.903L815.191 486.768Z",
    fill: "#4F859A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M616.543 963.411L649.539 981.992L682.128 962.708L681.724 924.837L648.728 906.256L616.135 925.546L616.543 963.411Z",
    fill: "#4F859A"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M650.059 903.892L683.055 922.472L715.644 903.188L715.24 865.318L682.244 846.737L649.652 866.026L650.059 903.892Z",
    fill: "#4F859A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M683.576 844.372L716.572 862.953L749.161 843.669L748.754 805.804L715.758 787.223L683.169 806.507L683.576 844.372Z",
    fill: "#4F859A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M717.093 784.852L750.089 803.433L782.678 784.149L782.271 746.284L749.275 727.703L716.686 746.987L717.093 784.852Z",
    fill: "#4F859A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M884.677 487.255L917.673 505.836L950.263 486.551L949.856 448.686L916.859 430.105L884.27 449.39L884.677 487.255Z",
    fill: "#4F859A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M918.194 427.735L951.19 446.316L983.779 427.032L983.372 389.167L950.376 370.586L917.787 389.87L918.194 427.735Z",
    fill: "#4F859A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M750.656 725.25L783.652 743.831L816.242 724.547L815.838 686.677L782.841 668.096L750.249 687.385L750.656 725.25Z",
    fill: "#4F859A"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M784.173 665.731L817.169 684.312L849.758 665.028L849.351 627.163L816.355 608.582L783.766 627.866L784.173 665.731Z",
    fill: "#4F859A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M817.69 606.211L850.686 624.792L883.275 605.508L882.868 567.643L849.872 549.062L817.283 568.346L817.69 606.211Z",
    fill: "#4F859A"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M851.207 546.692L884.203 565.273L916.792 545.989L916.385 508.123L883.389 489.543L850.8 508.827L851.207 546.692Z",
    fill: "#4F859A"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M686.028 963.897L719.024 982.478L751.614 963.194L751.21 925.324L718.214 906.743L685.621 926.032L686.028 963.897Z",
    fill: "#4F859A"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M719.545 904.378L752.541 922.959L785.13 903.675L784.723 865.809L751.727 847.229L719.138 866.513L719.545 904.378Z",
    fill: "#4F859A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M753.062 844.858L786.058 863.439L818.647 844.155L818.24 806.29L785.244 787.709L752.655 806.993L753.062 844.858Z",
    fill: "#4F859A"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M786.579 785.339L819.575 803.92L852.164 784.636L851.757 746.77L818.761 728.19L786.172 747.474L786.579 785.339Z",
    fill: "#4F859A"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M954.163 487.741L987.159 506.322L1019.75 487.038L1019.34 449.173L986.345 430.592L953.756 449.876L954.163 487.741Z",
    fill: "#4F859A"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M987.68 428.222L1020.68 446.802L1053.26 427.518L1052.86 389.653L1019.86 371.072L987.273 390.356L987.68 428.222Z",
    fill: "#4F859A"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M820.142 725.737L853.138 744.318L885.727 725.034L885.323 687.163L852.327 668.582L819.735 687.872L820.142 725.737Z",
    fill: "#4F859A"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M853.659 666.217L886.655 684.798L919.244 665.514L918.837 627.649L885.841 609.068L853.252 628.352L853.659 666.217Z",
    fill: "#4F859A"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M887.176 606.698L920.172 625.279L952.761 605.994L952.354 568.129L919.358 549.548L886.769 568.833L887.176 606.698Z",
    fill: "#4F859A"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M920.693 547.178L953.689 565.759L986.278 546.475L985.871 508.61L952.875 490.029L920.286 509.313L920.693 547.178Z",
    fill: "#4F859A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_59_598",
    x: 117,
    y: 41,
    width: 903,
    height: 903,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 72.5,
    result: "effect1_foregroundBlur_59_598"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagons1);
export default __webpack_public_path__ + "static/media/hexagons1.bebfeb3a022f6a3149238af83b78a133.svg";
export { ForwardRef as ReactComponent };